import axios from 'axios';
import Sortable from 'sortablejs';

export default class psProfileTools {
    constructor() {
        const container = document.getElementById('profile-tools');

        if (!container) {
            return;
        }

        // Container
        this.container = container;

        // Laddanimation
        this.loader = this.container.querySelector('.ajax-loading-edit-tools');

        this._init();
    }

    _init() {
        const editButton = this.container.querySelector('.profile-tools__profile-tools-edit');
        const toolsContainer = this.container.querySelector('#updatedtoolspartial');
        const editContainer = this.container.querySelector('.profile-tools__edit-items');
        const loader = this.container.querySelector('.ajax-loading-edit-tools');

        const toggleLoader = visible => loader.toggleAttribute('hidden', !visible);

        // Toggla redigering
        editButton.addEventListener('click', () => {
            const expanded = editButton.classList.toggle('profile-tools__edit-check-icon');
            const list = toolsContainer.querySelector('.profile-tools__items');
            list.toggleAttribute('hidden', !editContainer.toggleAttribute('hidden', !expanded));
            editButton.setAttribute('aria-expanded', expanded);
        });

        // Hantera �ndringar
        editContainer.addEventListener('change', async event => {
            event.preventDefault();
            const trigger = event.target;

            if (!(trigger && trigger.classList.contains('profil-unit-item'))) {
                return;
            }

            toggleLoader(true);

            try {
                const response = await axios.post(`/api/ps/profile/tools/${trigger.checked ? 'add' : 'remove'}`, { id: trigger.id });

                const div = document.createElement('div');
                div.innerHTML = response.data;
                div.firstElementChild.toggleAttribute('hidden', true);

                toolsContainer.firstElementChild.replaceWith(div.firstElementChild);

                if (!editContainer.querySelector('.profil-unit-item:checked')) {
                    for (const cb of editContainer.querySelectorAll('.profile-unit-item')) {
                        cb.checked = cb.dataset.default === 'true';
                    }
                }
            } catch (error) {
                this._error(error);
            }

            toggleLoader(false);
        });

        Sortable.create(editContainer, {
            handle: '.profile-tools__item-drag-wrapper',
            onUpdate: async event => {
                toggleLoader(true);

                const items = event.from.querySelectorAll('.profile-tools__item-container');
                const tools = [];

                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    item.setAttribute('data-index', i);
                    const cb = item.querySelector('.profil-unit-item');
                    if (cb && cb.checked) {
                        tools.push(item.getAttribute('data-id'));
                    }
                }

                try {
                    const response = await axios.post('/api/ps/profile/tools/sort', tools);
                    toolsContainer.innerHTML = response.data;

                    const items = toolsContainer.querySelector('.profile-tools__items');
                    items && items.toggleAttribute('hidden', true);
                }
                catch (error) {
                    this._error(error);
                }

                toggleLoader(false);
            }
        });
    }

    _error(error) {
        const id = error && error.response && error.response.status === 401 ? 'ps-profile-logged-out' : 'ps-profile-generic-error';
        const node = document.getElementById(id);
        node && alert(node.value);
    }
}
